var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.senderEmailAddress)?_c('InfoBranch',{style:({
      marginTop: '2px',
    }),attrs:{"content":_vm.senderEmailAddress,"description":"Send from"}}):_vm._e(),_vm._v(" "),(_vm.subject)?_c('InfoBranch',{style:({
      marginTop: '8px',
    }),attrs:{"content":_vm.subject,"description":"Subject"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }